<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M7.75 8.5C6.30025 8.5 5.125 7.32475 5.125 5.875C5.125 4.42525 6.30025 3.25 7.75 3.25C9.19975 3.25 10.375 4.42525 10.375 5.875C10.375 7.32475 9.19975 8.5 7.75 8.5Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12.25 3.25C13.6997 3.25 14.875 4.42525 14.875 5.875C14.875 7.32475 13.6997 8.5 12.25 8.5" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.75102 10.75C5.02231 10.75 2.71904 12.3438 1.99085 14.5257C1.72858 15.3114 2.42259 16 3.25102 16H12.251C13.0794 16 13.7735 15.3114 13.5112 14.5257C12.783 12.3438 10.4797 10.75 7.75102 10.75Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M16.375 16.0002H16.75C17.5784 16.0002 18.2724 15.3117 18.0102 14.526C17.4944 12.9803 16.188 11.7297 14.5 11.1318" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'SubmissionIcon',
  props: {
    width: {
      type: Number,
      default: 20,
    },
    height: {
      type: Number,
      default: 20,
    }
  }
}
</script>

<style scoped></style>